import styled from "styled-components"
import {Button} from "@malwarebytes/react-components"

export const FullWidthButton = styled(Button)`
    width: 100%;
`
